import { FormattedMessage, FormattedNumber } from 'react-intl'

import { Divider } from '@gto/ui/divider'
import { Typography } from '@gto/ui/typography'

import { DataTable } from '@/components/data-table'
import type { FlipOutRow } from '@/pages/promotion/hooks/use-flip-out-prizes-table-cols'
import { useFlipOutPrizesTableCols } from '@/pages/promotion/hooks/use-flip-out-prizes-table-cols'

export const FlipOutPrizesTable = ({ rows }: { rows: FlipOutRow[] }) => {
  const columns = useFlipOutPrizesTableCols()

  return (
    <DataTable
      columns={columns}
      data={rows}
      getRowId={(row) => row.id}
      footer={
        <div className="flex gap-2 px-2 py-6">
          <Typography
            className="font-medium"
            variant="body2"
          >
            <FormattedMessage
              id="promo.rakeRace.table.totalPrizes"
              values={{
                total: rows.reduce((acc, row) => acc + row.prizesCount, 0),
              }}
            />
          </Typography>
          <Divider
            flexItem
            orientation="vertical"
          />
          <Typography
            className="font-medium"
            variant="body2"
          >
            <FormattedNumber
              currency="USD"
              maximumFractionDigits={0}
              style="currency"
              value={rows.reduce((acc, row) => acc + row.totalValue, 0)}
            />
          </Typography>
        </div>
      }
    />
  )
}
